module.exports = __webpack_public_path__ + "624d8a6b5ffb5fca686e7236c7e03595.png";